import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatusCard } from '@node-space/storybook-components/dist/StatusCard'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Box, Text } from '@node-space/ui-components'

export const CustomersEmptyView = () => {
  const { t } = useTranslation()

  return (
    <StatusCard headline={t('embeddedCustomers.emptyStatus.headline')}>
      <Box>
        <Text isCentered>{t('embeddedCustomers.emptyStatus.descriptionIntegrated')}</Text>
        <Text isCentered>{t('embeddedCustomers.emptyStatus.descriptionCustomerDetails')}</Text>
      </Box>
      <Text isCentered>
        {t('embeddedCustomers.emptyStatus.ctaPreLink')}
        <TextAction
          text={t('embeddedCustomers.emptyStatus.ctaLink')}
          linkTo={process.env.DEVELOPER_DOCS}
          inheritColor
        />
        .
      </Text>
    </StatusCard>
  )
}
